<template>
  <el-form labelPosition="top">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="Наименование">
          <el-input v-model="property.name"></el-input>
        </el-form-item>
        <el-form-item label="Описание">
          <el-input v-model="property.description" type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <div>
            <el-checkbox v-model="property.unit">Еденица измерения</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="Тип свойства">
          <el-select v-model="property.type" @change="onTypeChange">
            <el-option v-for="type in types" :key="type.key" :value="type.key" :label="type.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Значение по умолчанию" v-if="property.type !== 'select'">
          <el-input v-if="property.type == 'string'" v-model="property.default"></el-input>
          <el-input type="number" v-if="property.type == 'number'" v-model="property.default"></el-input>

          <el-radio-group v-if="property.type == 'boolean'" @change="$forceUpdate()" v-model="property.default">
            <el-radio-button label="true">Да</el-radio-button>
            <el-radio-button label="false">Нет</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="10" :offset="2">
        <el-form-item label="Список допустимых значений" v-if="property.type == 'select'">
          <el-button type="primary" @click="addSelectValue">Добавить</el-button>
          <el-table :data="property.selectOptions" v-if="property.selectOptions && property.selectOptions.length"
                    size="mini">
            <el-table-column label="Значение">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="По умолчанию" align="right">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.default" :disabled="scope.row.default"
                             @change="val => onDefaultSelectOptionChange(val, scope.$index)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="Действия" align="right">
              <template slot-scope="scope">
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeSelectValue(scope.$index)"
                           circle></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-col>

    </el-row>
  </el-form>
</template>

<script>
  import PropertyTypes from './types'

  export default {
    props: ['property', 'readonly'],
    data: () => ({
      types: PropertyTypes,
      state: {
        loading: false
      },
    }),
    methods: {
      onTypeChange(type) {
        this.property.default = ''
        if (type === 'select' && !this.property.selectOptions) {
          this.property.selectOptions = []
        }
      },
      addSelectValue() {
        let option = {name: ''}
        if (!this.property.selectOptions.length) {
          option.default = true
        }
        this.property.selectOptions.push(option)
        this.$forceUpdate()
      },
      removeSelectValue(index) {
        let isDefault = this.property.selectOptions[index]['default']

        this.property.selectOptions.splice(index, 1)
        if (isDefault && this.property.selectOptions.length) {
          this.property.selectOptions[0]['default'] = true
        }
      },
      onDefaultSelectOptionChange(val, index) {
        if (!val) return
        this.property.selectOptions.forEach((option, i) => {
          if (index !== i) {
            option['default'] = false
          }
        })
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/modules/settings/components/Properties/form.vue